export const pathAssetsBase: string = import.meta.env.VITE_APP_PATH_ASSETS ||
    'https://appspowerplaymanager.vshcdn.net/images/winter-sports/minigame/'
export const pathAssets = `${pathAssetsBase}bobsleigh`
export const pathAssetsGlobal = `${pathAssetsBase}global`
